import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/services/firebase/config';
import { useAuth } from '@/contexts/AuthContext';
import type { UserPlan } from '@/utils/planLimits';

interface UserProfile {
  plan: UserPlan;
}

/**
 * Hook to fetch the current user's plan from Firestore
 * Returns 'free' by default if no plan is found
 */
export const useUserPlan = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['userPlan', user?.uid],
    queryFn: async (): Promise<UserPlan> => {
      if (!user?.uid) return 'free';

      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) return 'free';

      const data = userDoc.data() as UserProfile;
      return data.plan || 'free';
    },
    enabled: !!user?.uid,
    staleTime: 30 * 1000, // Cache for 30 seconds
  });
};
